import { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

export default function FormErrorNotification({
  errorMessage,
}: Readonly<{
  errorMessage?: string;
}>): ReactElement | null {
  if (!errorMessage) return null;

  return (
    <div className="mt-2 flex items-center text-brick">
      <div className="self-start">
        <FontAwesomeIcon icon={faCircleExclamation} className="mr-1" />
      </div>
      <span className="text-sm">{errorMessage}</span>
    </div>
  );
}
